"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coulomb = void 0;
var uom_1 = require("uom");
var UnitTimes = require("../unit-times");
/**
 * The derived unit for electric charge, quantity of electricity ( <code>C</code> ).
 * One Coulomb is equal to the quantity of charge transferred in one second by a steady current of one ampere.
 * It is named after the French physicist Charles Augustin de Coulomb (1736-1806).
 */
exports.Coulomb = UnitTimes.durationByElectricCurrent("Coulomb", uom_1.BaseUnits.Second, uom_1.BaseUnits.Ampere);
//# sourceMappingURL=electric-charge.js.map